import { ReportRun } from 'dashboard/models/report-run';
import ReportRunDetailsSummary from 'dashboard/modules/ResourceReportRun/ReportRunDetailsSummary';
import { ApiModel } from 'lib/interfaces/api';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

interface ResourceReportRunProps {
  reportRun: ReportRun;
  defaultAccordionOpen: boolean;
  featureFlags: FeatureFlagsMap;
}

const ResourceReportRun = ({ reportRun, defaultAccordionOpen }: ResourceReportRunProps) => {
  switch (reportRun.type) {
    case ApiModel.ReportRunCustomList:
      return (
        <ReportRunDetailsSummary
          accordion={true}
          reportRun={reportRun}
          isDefaultOpen={defaultAccordionOpen}
        />
      );
    default:
      return <> Report does not support report runs! </>;
  }
};

export default ResourceReportRun;
